import { mapState} from 'vuex'

export default {
    beforeMount () {
        this.$store.dispatch('dashboard/fetchNotifications', {
            'userId': this.currentUser.uid,
            'shouldResetNotifications': false,
        })
    },
    computed: {
        ...mapState('user', {
            userProfile: state => state.userProfile,
            currentUser: state => state.currentUser,
        }),
        ...mapState('dashboard', {
            notifications: state => state.notifications,
            notificationsCount: state => state.notificationsCount,
        }),
    },
    methods: {

        /**
         * Get the related notification type class color and apply it
         * to the desired html widget
         *
         * @param notificationType
         * @returns {{"text-success": boolean, "text-primary": boolean, "text-danger": boolean, "text-warning": boolean}}
         */
        getVerticalBarColor(notificationType) {
            return {
                'text-warning': notificationType === "VISIT_SEARCH",
                'text-info': notificationType === "VISIT_URL",
                'text-danger': notificationType === "PROFILE_LIKE",
                'text-success': notificationType === 'VISIT_QRCODE',
                'text-primary': notificationType === 'VISIT_NFC',
                'color-referral': notificationType === 'PROFILE_REFERRAL_ADDED',
            }
        }

    }
};


// WEBPACK FOOTER //
// ./src/pages/dashboard/components/overview/dashboard-notifications/dashboard-notifications.js